import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = {
  key: 0,
  class: "mt-2 border border-gray-400 rounded"
}
const _hoisted_3 = { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }
const _hoisted_4 = { class: "w-full px-4 py-2 space-y-2 border-b border-gray-300" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "pt-0 text-sm text-gray-600" }, "Description for internal use only", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}, "Please select", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}, "Please select", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_11 = { class: "space-y-2.5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}, "Please select", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "e-learning"
}, "E-learning", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "in-person"
}, "In person", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "live-webinar"
}, "Live Webinar", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "webinar"
}, "Webinar", -1)
const _hoisted_17 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "space-y-2.5" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", {
  class: "capitalize",
  value: "0",
  selected: "",
  disabled: ""
}, "Please select", -1)
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600" }, " When users book onto events under this course, they will be automatically enrolled on this Moodle Course. Please note, this will only enrol the user in the language of the Moodle Course regardless of their language preference. ", -1)
const _hoisted_22 = { class: "mt-2 text-base capitalize" }
const _hoisted_23 = { class: "mt-2 ml-2 list-disc list-inside" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "text-red-500" }
const _hoisted_26 = { class: "w-full table-auto" }
const _hoisted_27 = { class: "font-bold text-left border-b-2 border-black divide-x-2 divide-gray-400" }
const _hoisted_28 = {
  scope: "col",
  class: "w-1/5 px-2 py-2 capitalize"
}
const _hoisted_29 = {
  scope: "col",
  class: "w-3/5 px-2 py-2 capitalize"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "w-1/5 px-2 py-2"
}, null, -1)
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "text-red-500" }
const _hoisted_33 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_34 = { class: "px-2 py-2" }
const _hoisted_35 = { class: "flex px-2 py-2 mt-1 space-x-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "border-r border-gray-400" }, null, -1)
const _hoisted_37 = {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_38 = {
  class: "capitalize",
  value: true
}
const _hoisted_39 = {
  class: "capitalize",
  value: false
}
const _hoisted_40 = {
  class: "capitalize",
  value: "no-change"
}
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  key: 2,
  class: "w-full border-b border-gray-300"
}
const _hoisted_43 = { class: "flex items-center" }
const _hoisted_44 = { class: "flex w-full px-4 py-2 md:w-1/2 lg:w-2/3" }
const _hoisted_45 = { class: "text-lg font-medium capitalize" }
const _hoisted_46 = { class: "px-4 py-2 md:w-1/2 lg:w-1/2" }
const _hoisted_47 = { class: "flex" }
const _hoisted_48 = { class: "px-4 py-4 bg-gray-100 border-t border-gray-400" }
const _hoisted_49 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_50 = { class: "space-y-2.5" }
const _hoisted_51 = { class: "flex items-center justify-between" }
const _hoisted_52 = { class: "mt-4" }
const _hoisted_53 = {
  href: "https://app.storyblok.com/#/login?redirect=https://app.storyblok.com/#/me/spaces",
  target: "_blank",
  class: "underline text-blue"
}
const _hoisted_54 = {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_55 = ["value"]
const _hoisted_56 = { class: "flex flex-wrap gap-4 py-6" }

import { ref, computed, watch } from "vue";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";

import RegistrationRulesModal from "@/components/modals/RegistrationRulesModal.vue";
import AddCountryPriceModal from "@/components/modals/AddCountryPriceModal.vue";
import StoryblockDescription from "@/components/StoryblockDescription.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import PriceDisplay from "@/components/PriceDisplay.vue";
import TagSelector from "@/components/TagSelector.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import AlertCard from "@/components/AlertCard.vue";
import TabGroup from "@/components/TabGroup.vue";

import api from "@/api/api";
import { useGlobalStore, useUserStore } from "@/store";
import { CountryPrice, CreateTemplateRequest, Level, Role } from "@/types";
import { useI18n } from "vue-i18n";
import { userHasRole } from "@/utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewTemplate',
  async setup(__props) {

let __temp: any, __restore: any

const { t: $t } = useI18n();

const router = useRouter();
const globalStore = useGlobalStore();
const userStore = storeToRefs(useUserStore());
const { course_types, course_roles } = storeToRefs(useGlobalStore());

const isTemplatesLoading = ref(false);
const isRegistrationRulesModalOpen = ref(false);
const isCountryPriceModalOpen = ref(false);
const isSaving = ref(false);

const showCountryPricingError = ref(false);
const showRegistrationRulesError = ref(false);

const storyblokTemplates = ref([] as { [key: string]: any }[]);
const story = ref();

const moodle_courses = ref([] as { [key: string]: any }[]);

const template = ref({
  name: "",
  description: "",
  type: "",
  level: "",
  subscription: "no-change",
  confirmation_message: "",
  countries: [],
  delivery: "",
  registration_method: "",
  required_roles: [],
  storyblok_id: "0",
  storyblok_slug: "",
  tags: [],
  merchant_product_code: "",
  moodle_course_id: 0,
  requires_subscription: false,
  order: null,
} as CreateTemplateRequest);
const levels = ref([] as Level[]);
const selectedCountryPrice = ref({} as CountryPrice);

const tabs = [
  {
    id: "summary",
    name: "Summary",
  },
  {
    id: "course-description",
    name: "Course Details",
  },
];
const selectedTab = ref("summary");

const showMerchantProductCodeField = computed(() => {
  // Check if this will be a digital or physical producft
  if (template.value.delivery === "in-person") {
    return false;
  }

  // Check if there's a country other than UK in the countries array.
  if (!template.value.countries.find(i => i.country !== "united kingdom")) {
    return false;
  }

  return true;
});

async function editCountryPrice(countryprice: CountryPrice) {
  showCountryPricingError.value = false;
  selectedCountryPrice.value = countryprice;
  isCountryPriceModalOpen.value = true;
}

async function setStoryBlokProperties(e: any) {
  const selectedTemplate = storyblokTemplates.value.find(i => i.id == e.target.value);
  story.value = selectedTemplate;

  template.value.storyblok_slug = `/${selectedTemplate?.full_slug}`;
  template.value.storyblok_id = selectedTemplate?.id.toString() || "0";
}

function setRegistrationRules(roles: Role[]) {
  showRegistrationRulesError.value = false;
  isRegistrationRulesModalOpen.value = false;

  template.value.required_roles = roles.sort((a: Role, b: Role) => {
    return a.id - b.id;
  });

  // Check and filter out any duplicates
  const uniqueRoles = template.value.required_roles.filter((role: Role, index: number) => {
    return (
      template.value.required_roles.findIndex((r: Role) => r.id === role.id) === index
    );
  });

  template.value.required_roles = uniqueRoles;
}

async function setTemplateTags(e: number[]) {
  template.value.tags = e;
}

function setCountryPrice(country: CountryPrice) {
  isCountryPriceModalOpen.value = false;

  if (template.value.countries.find(i => i.country == country.country)) {
    const countryIndex = template.value.countries.findIndex(i => i.country === country.country);
    template.value.countries.splice(countryIndex, 1);
  }

  template.value.countries.push(country);
}

function removeCountryPrice(index: number) {
  template.value.countries.splice(index, 1);
}

async function saveTemplate() {
  if (!template.value.required_roles.length) {
    return (showRegistrationRulesError.value = true);
  }

  if (!template.value.countries.length) {
    return (showCountryPricingError.value = true);
  }

  if(!template.value.storyblok_slug) {
    return globalStore.toast("ERROR", "Please select a course description");
  }

  if (template.value.type === "training" && template.value.level === "All") {
    return globalStore.toast("ERROR", "Training can only be associated to levels; Certified Facilitator, Advanced Facilitator, Level 1 and 2 Combined and Level 4 mentor");
  }

  try {
    isSaving.value = true;

    const response = await api.templates.createTemplate(template.value);

    if (response.meta.status === 200) {
      globalStore.toast("SUCCESS", $t("template-created"));
      return router.push({ name: "Course_Template", params: { id: response.data.template.id } });
    }
  } catch (e) {
    console.log("ERROR", e);
    isSaving.value = false;
    globalStore.toast("ERROR", $t("error-creating-template"));
  }
}

async function fetchStoryblockTemplates() {
  isTemplatesLoading.value = true;
  const response = await api.storyblok.listTemplateDescriptions();
  storyblokTemplates.value = response.templates;
  
  isTemplatesLoading.value = false;
}

if (!userHasRole(userStore.user.value.roles, ["admin", "courses-admin", "clubs-admin", "users-admin"])) {
  globalStore.toast("ERROR", $t("unauthorized"));
  window.location.href = "/error";
} else {
  (
  ([__temp,__restore] = _withAsyncContext(() => fetchStoryblockTemplates())),
  await __temp,
  __restore()
);
  levels.value = (
  ([__temp,__restore] = _withAsyncContext(async () => ((
  ([__temp,__restore] = _withAsyncContext(() => api.templates.listTemplateLevels())),
  __temp = await __temp,
  __restore(),
  __temp
)).data.levels)),
  __temp = await __temp,
  __restore(),
  __temp
);
  moodle_courses.value = (
  ([__temp,__restore] = _withAsyncContext(async () => ((
  ([__temp,__restore] = _withAsyncContext(() => api.templates.listMoodleCourses())),
  __temp = await __temp,
  __restore(),
  __temp
)).data.courses)),
  __temp = await __temp,
  __restore(),
  __temp
);
}

watch(
  () => template.value.type,
  () => {
    const noChangeTypes = ["cpd-courses-for-certified-facilitators", "continual-professional-development", "introductory"];

    if (noChangeTypes.includes(template.value.type)) {
      template.value.subscription = "no-change";
    } else {
      template.value.subscription = "";
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(AddCountryPriceModal, {
        isOpen: isCountryPriceModalOpen.value,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (isCountryPriceModalOpen.value = false)),
        onSelect: setCountryPrice,
        "existing-country-price": selectedCountryPrice.value
      }, null, 8, ["isOpen", "existing-country-price"]),
      _createVNode(RegistrationRulesModal, {
        required_roles: template.value.required_roles,
        isOpen: isRegistrationRulesModalOpen.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (isRegistrationRulesModalOpen.value = false)),
        onSelect: setRegistrationRules
      }, null, 8, ["required_roles", "isOpen"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _unref($t)('new-course')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("form", {
      onSubmit: _withModifiers(saveTemplate, ["prevent"]),
      class: "mt-8"
    }, [
      _createVNode(TabGroup, {
        tabs: tabs,
        selectedTab: selectedTab.value,
        onSelect: _cache[2] || (_cache[2] = (tab) => selectedTab.value = tab)
      }, null, 8, ["selectedTab"]),
      (selectedTab.value === 'summary')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref($t)("key-programme-details")), 1),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "name",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((template.value.name) = $event)),
                placeholder: "course name...",
                class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                required: ""
              }, null, 512), [
                [_vModelText, template.value.name]
              ]),
              _withDirectives(_createElementVNode("textarea", {
                type: "text",
                id: "description",
                placeholder: "course description...",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((template.value.description) = $event)),
                class: "block w-full h-16 py-2 text-gray-900 border border-gray-600 rounded"
              }, null, 512), [
                [_vModelText, template.value.description]
              ]),
              _hoisted_5
            ]),
            _createVNode(ListRowItem, {
              title: _unref($t)('course-level')
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  id: "subscription",
                  class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((template.value.level) = $event)),
                  required: ""
                }, [
                  _hoisted_6,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(levels.value, (level) => {
                    return (_openBlock(), _createElementBlock("option", {
                      class: "capitalize",
                      value: level.name,
                      key: level.id
                    }, _toDisplayString(level.name), 9, _hoisted_7))
                  }), 128))
                ], 512), [
                  [_vModelSelect, template.value.level]
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _unref($t)('course-type')
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  id: "subscription",
                  class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((template.value.type) = $event)),
                  required: ""
                }, [
                  _hoisted_8,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(course_types), (t) => {
                    return (_openBlock(), _createElementBlock("option", {
                      class: "capitalize",
                      value: t.slug,
                      key: t.slug
                    }, _toDisplayString(_unref($t)(t.slug)), 9, _hoisted_9))
                  }), 128))
                ], 512), [
                  [_vModelSelect, template.value.type]
                ]),
                (template.value.type === 'training' && template.value.level === 'All')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Training can only be associated to levels; Certified Facilitator, Advanced Facilitator, Level 1 and 2 Combined and Level 4 mentor "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _unref($t)('delivery-method')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("select", {
                      id: "subscription",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((template.value.delivery) = $event)),
                      class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                      required: ""
                    }, _hoisted_17, 512), [
                      [_vModelSelect, template.value.delivery]
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            (['e-learning', 'webinar'].includes(template.value.delivery))
              ? (_openBlock(), _createBlock(ListRowItem, {
                  key: 0,
                  title: _unref($t)('moodle-course')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("select", {
                          id: "subscription",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((template.value.moodle_course_id) = $event)),
                          class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600"
                        }, [
                          _hoisted_19,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moodle_courses.value, (course) => {
                            return (_openBlock(), _createElementBlock("option", {
                              class: "capitalize",
                              value: course.id,
                              key: course.id
                            }, _toDisplayString(course.displayname), 9, _hoisted_20))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, template.value.moodle_course_id]
                        ])
                      ]),
                      _hoisted_21
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(ListRowItem, {
              title: _unref($t)('registration-rules'),
              flex: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_22, _toDisplayString(_unref($t)("registration-rules")), 1),
                _createElementVNode("ul", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.value.required_roles.sort((a, b) => a.order - b.order), (role) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: role.id
                    }, _toDisplayString(_unref($t)(role.name)), 1))
                  }), 128))
                ]),
                (showRegistrationRulesError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("p", _hoisted_25, _toDisplayString(_unref($t)("please-add-atleast-1-rule")), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(DefaultButton, {
                  type: "primary",
                  class: "mt-4",
                  onAction: _cache[9] || (_cache[9] = ($event: any) => (isRegistrationRulesModalOpen.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("edit-registration-rules")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _unref($t)('countries-and-pricing'),
              flex: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("table", _hoisted_26, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_27, [
                      _createElementVNode("th", _hoisted_28, _toDisplayString(_unref($t)("country")), 1),
                      _createElementVNode("th", _hoisted_29, _toDisplayString(_unref($t)("pricing")), 1),
                      _hoisted_30
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (showCountryPricingError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("p", _hoisted_32, _toDisplayString(_unref($t)("please-add-atleast-one-country")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.value.countries, (country, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "border-b border-gray-400 divide-x-2 divide-gray-400 odd:bg-gray-200",
                        key: index
                      }, [
                        _createElementVNode("td", _hoisted_33, _toDisplayString(country.country), 1),
                        _createElementVNode("td", _hoisted_34, [
                          _createVNode(PriceDisplay, {
                            locale: "en-GB",
                            price: country.pricing,
                            currency: country.currency,
                            vat: country.vat
                          }, null, 8, ["price", "currency", "vat"])
                        ]),
                        _createElementVNode("td", _hoisted_35, [
                          _createVNode(DefaultButton, {
                            type: "text",
                            onAction: ($event: any) => (editCountryPrice(country))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref($t)("edit")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onAction"]),
                          _hoisted_36,
                          _createVNode(DefaultButton, {
                            type: "text",
                            onAction: ($event: any) => (removeCountryPrice(index))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref($t)("delete")), 1)
                            ]),
                            _: 2
                          }, 1032, ["onAction"])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createVNode(DefaultButton, {
                  type: "primary",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (isCountryPriceModalOpen.value = true)),
                  class: "mt-4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("add-a-country-price")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _unref($t)('requires-a-subscription')
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  id: "subscription",
                  class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((template.value.requires_subscription) = $event)),
                  required: ""
                }, [
                  _createElementVNode("option", _hoisted_37, _toDisplayString(_unref($t)("please-select")), 1),
                  _createElementVNode("option", _hoisted_38, _toDisplayString(_unref($t)("yes")), 1),
                  _createElementVNode("option", _hoisted_39, _toDisplayString(_unref($t)("no")), 1)
                ], 512), [
                  [_vModelSelect, template.value.requires_subscription]
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            (template.value.type !== 'drop-in')
              ? (_openBlock(), _createBlock(ListRowItem, {
                  key: 1,
                  title: _unref($t)('subscription-level-on-completion')
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("select", {
                      id: "subscription",
                      class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((template.value.subscription) = $event)),
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_40, _toDisplayString(_unref($t)("no-change")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(course_roles), (role) => {
                        return (_openBlock(), _createElementBlock("option", {
                          class: "capitalize",
                          value: role.name,
                          key: role.id
                        }, _toDisplayString(_unref($t)(role.name)), 9, _hoisted_41))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, template.value.subscription]
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            (_unref(showMerchantProductCodeField))
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("h2", _hoisted_45, _toDisplayString(_unref($t)("verifone-product-code")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "payment",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((template.value.merchant_product_code) = $event)),
                          class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
                        }, null, 512), [
                          [_vModelText, template.value.merchant_product_code]
                        ])
                      ])
                    ])
                  ]),
                  _createVNode(AlertCard, {
                    type: "warning",
                    class: "mx-4 mt-6 mb-2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref($t)("merchant-product-code-helptext")), 1),
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, _toDisplayString(_unref($t)("merchant-product-code-warning")), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(TagSelector, {
                onChange: setTemplateTags,
                type: "event"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (selectedTab.value === 'course-description')
        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
            _createVNode(ListRowItem, {
              title: _unref($t)('storyblok-description'),
              class: "bg-play-gray",
              flex: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("label", _hoisted_52, [
                        _createTextVNode(_toDisplayString(_unref($t)("select-course-description")) + " (", 1),
                        _createElementVNode("a", _hoisted_53, _toDisplayString(_unref($t)("view-course-in-cms")), 1),
                        _createTextVNode(")")
                      ]),
                      _createVNode(DefaultButton, {
                        type: "primary",
                        loading: isTemplatesLoading.value,
                        disabled: isTemplatesLoading.value,
                        onAction: fetchStoryblockTemplates
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Refresh")
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled"])
                    ]),
                    _createElementVNode("select", {
                      id: "storyblok_description",
                      onChange: setStoryBlokProperties,
                      class: "capitalize text-black border w-full mt-2 rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_54, _toDisplayString(_unref($t)("please-select")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storyblokTemplates.value, (template) => {
                        return (_openBlock(), _createElementBlock("option", {
                          class: "capitalize",
                          value: template.id,
                          key: template.slug
                        }, _toDisplayString(template.name), 9, _hoisted_55))
                      }), 128))
                    ], 32)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            (story.value && story.value.uuid)
              ? (_openBlock(), _createBlock(StoryblockDescription, {
                  key: 0,
                  class: "pt-6",
                  story: story.value
                }, null, 8, ["story"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_56, [
        _createVNode(DefaultButton, {
          type: "primary",
          "is-form-submit": true,
          loading: isSaving.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref($t)("save-course-template")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 40, _hoisted_1)
  ], 64))
}
}

})